
<template>
  <v-dialog
    v-model="innerVal"
    max-width="400px"
    persistent
  >
    <v-card
      class="px-5 py-10"
      rounded="lg"
    >
      <v-card-text>
        <slot>
          <h2 class="text-center">
            {{ message }}
          </h2>
        </slot>
      </v-card-text>
      <v-card-actions class="d-flex justify-center">
        <!-- Cancel Btn -->
        <v-btn
          v-if="!noCancelButton"
          rounded
          depressed
          color="blue lighten-4 primary--text"
          width="100px"
          class="mx-3 text-none"
          @click="cancelAction"
        >
          Cancel
        </v-btn>
        <!-- Confirm Btn -->
        <v-btn
          rounded
          depressed
          color="primary"
          width="100px"
          class="mx-3 text-none"
          @click="confirmAction"
        >
          {{ confirmButton }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'BaseConfirmationDialog',

    props: {
      value: { type:Boolean, default:false },
      message: { type:String, default:'' },
      confirmButton: { type:String, default:'Yes' },
      noCancelButton: { type:Boolean, default:false },
    },

    data() {
      return {
        innerVal: this.value
      }
    },

    watch: {
      value(val) {
        this.innerVal = val
      },
      innerVal(val) {
        this.$emit('input', val)
      }
    },

    methods: {
      cancelAction() {
        this.innerVal = false
        this.$emit('cancel')
      },
      confirmAction() {
        this.innerVal = false
        this.$emit('confirm')
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>